/** @typedef {import('../../core/services/locale.service').LocaleService} LocaleService */

/**
 * Use the locale with the given country ID on the page where this directive is used.
 * @param {LocaleService} localeService Any instance of the locale service.
 * @returns {any} The locale directive.
 */
export function LocaleDirective(localeService) {
    'ngInject'
    return {
        restrict: "A",
        link: function (scope, el, attrs) {
            // The countryID is passed in with this directive's attribute value.
            // eg, <div apex-locale="2">...
            const countryID = Number(attrs.apexLocale);
            if (countryID) {
                // Set the default locale based on the attributes passed into the directive.
                localeService.retrieveLocales()
                    .then(function (locales) {
                        return locales.filter(function (locale) {
                            return locale.countryID === countryID;
                        })[0];
                    })
                    .then(function (defaultLocale) {
                        return localeService.setDefaultLocale(defaultLocale.localeID);
                    });
            }
        }
    };
}
